$(document).ready(function () {
  /**slick slider start**/
  $(".Banner_wrapper").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    infinite: true,
  });

  $(".home_collection_slider").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false,
        },
      },
    ],
  });

  $(".review_slider").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: true,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  $(".home_blog_slider").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: true,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
        },
      },
    ],
  });

  $(".home_featured__collection_slider").slick({
    responsive: [
      {
        breakpoint: 989,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: false,
          arrows: false,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
          arrows: false,
        },
      },
    ],
  });
  /**slick slider end**/

  /*faq jquery  start*/
  $(".set a:first").addClass("active");
  $(".set a:first").siblings(".content").slideDown(200);
  $(".set a:first").find("i").removeClass("fa-plus").addClass("fa-minus");
  $(".set > a").on("click", function () {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).siblings(".content").slideUp(200);
      $(".set > a i").removeClass("fa-minus").addClass("fa-plus");
    } else {
      $(".set > a i").removeClass("fa-minus").addClass("fa-plus");
      $(this).find("i").removeClass("fa-plus").addClass("fa-minus");
      $(".set > a").removeClass("active");
      $(this).addClass("active");
      $(".content").slideUp(200);
      $(this).siblings(".content").slideDown(200);
    }
  });
  /*faq jquery end */
  
  $("#custom-button").on("click", function (event) {
    var video = document.getElementById('custom-video-frame');
    //$(".deferred-media__poster-button").trigger("click");
     if(video.paused){
          video.play();
       $(".deferred-media__poster-button").hide();
      }else{
          video.pause();
      }
  });

  function Variantchange(color,size) {
      debugger;
    var data_f_value = [],data_s_value = [],input_data = [color,size], values_f = [], values_s = [];         
  
    $(".ph-variant option").each(function(){          
      data_f_value.push($(this).attr('data-first-value')); 
      data_s_value.push($(this).attr('data-second-value'));           
    });    
                                                      

    var x = input_data;    
    var y = data_f_value;
    var z = data_s_value;   
    
    x.forEach( function (i) { 
      if(y.indexOf(i) >= 0) {
        values_f.push(i);
      }
      if(z.indexOf(i) >= 0) { 
       values_s.push(i);
      }
    });
    
    var f_data = values_f;
    var s_data = values_s;      

    if( $.inArray(f_data,data_f_value) == -1 && $.inArray(s_data,data_s_value) == -1  ){ 
      f_data = f_data.toString();
      s_data = s_data.toString();
      $(".ph-variant option").removeClass('first_value');
      $(".ph-variant option").removeClass('second_value'); 
      $(".ph-variant option[data-first-value='" + f_data + "']").addClass('first_value');
      $(".ph-variant option[data-second-value='" + s_data + "']").addClass('second_value');          
    }

    $(".ph-variant option").removeAttr('selected');    
    $('.product-form__cart-submit').attr('disabled','disabled');
    $(".ph-variant option").each(function(){         
      if($(this).hasClass('first_value second_value')){           
        $(this).attr('selected', 'selected');     
         
        var variantId = $(this).val();
        $(".template-product product-form .product-variant-id").val(variantId);
        if($(this).attr("data-media-src")){
          $('.template-product li.is-active .product__media img').attr("src",$(this).attr("data-media-src"));
          $('.template-product li.is-active .product__media img').attr("srcset",$(this).attr("data-media-src"));
        }
        var dsku = $(this).attr("data-sku");
        var dprice = $(this).attr("data-price");
        var dcompare_at_price= $(this).attr('data-compare_at_price');
        var dquantity = $(this).attr('data-quantity');
        
        setTimeout(function () {
          if(dcompare_at_price == ""){
            $('.price__badge-sale').hide();
          } 
          $(".price").parent(".no-js-hidden").removeClass("visibility-hidden");
          $(".product__sku").removeClass("visibility-hidden");
          $(".product__sku").text(dsku);
          $(".product__sku span").text(dsku);
          $(".price__regular .price-item--regular").text(dprice);
          $('.price__sale .price-item').text(dprice);
          $('.price__sale .price-item--regular').text(dcompare_at_price);
          
          if(dquantity > 0 ){            
            $(".template-product .product-form__submit").removeAttr("disabled");
            $(".template-product .product-form__submit span").text("Add to cart");
          }else{
          $(".template-product .product-form__submit").attr("disabled","disabled");
           $(".template-product .product-form__submit span").text("Sold out");
          }
          
        }, 500);
        
      }
    }); 
   
  }
  $(document).on("click",".template-product variant-radios input.option-color",function () {    
      var color = $(this).val(), size = $(".template-product variant-selects select.option-size option:selected").val();
      Variantchange(color,size);     
    });

  $(document).on("change", ".template-product .option-size", function () {
      var size = $(this).val(), color = $(".template-product variant-radios .option-color:checked").val();   
      Variantchange(color,size);
  }); 

  /*product page accrodian js */


  $(".accordion-new").first().find(".heading-new").addClass('active');
  $(".contents-new").hide();
  $(".accordion-new").first().find(".contents-new").show();
  $(".accordion-new").on("click", ".heading-new", function() {
    $(".heading-new").not(this).removeClass("active");
    $(this).toggleClass("active").next().slideToggle();
    $(".contents-new").not($(this).next()).slideUp(300);
  });


});

/* map4 video paly on scroll */
window.addEventListener('load', videoScroll);
window.addEventListener('scroll', videoScroll);

function videoScroll() {

  if ( document.querySelectorAll('.video').length > 0) {
    var windowHeight = window.innerHeight,
        videoEl = document.querySelectorAll('.video');

    for (var i = 0; i < videoEl.length; i++) {

      var thisVideoEl = videoEl[i],
          videoHeight = thisVideoEl.clientHeight,
          videoClientRect = thisVideoEl.getBoundingClientRect().top;

      if ( videoClientRect <= ( (windowHeight) - (videoHeight*.5) ) && videoClientRect >= ( 0 - ( videoHeight*.5 ) ) ) {
        thisVideoEl.play();
      } else {
        thisVideoEl.pause();
      }

    }
  }
/* map4 video paly on scroll */
}


  

